<template>
  <div>
    <div
      id="sidebar"
      :class="'w-[300px] fixed lg:left-0 -left-[300px]  top-0 lg:mt-5 mt-0 h-[96vh] z-40 pl-7'"
    >
      <div
        class="bg-white w-[262px] h-[100%] lg:rounded-[30px] rounded-none overflow-auto s_scrollbar"
      >
        <div class="h-[96vh]">
          <div
            class="sidebar_logo flex flex-col justify-center items-center pt-8"
          >
            <span class="pb-1">
              <img
                src="../../assets/images/s-dashboard/E-logo.png"
                alt="logo"
              />
            </span>
            <span>
              <p class="font-[InterBlack]">HIGH IMPACT CAREERS</p>
            </span>
          </div>
          <div class="pt-8 mb-20">
            <ul @click="close">
              <li>
                <router-link
                  exact-path
                  :to="{ name: 'dashboard' }"
                  class="flex text-[#9295A3] py-1.5 pl-5 mb-3 s_sidebar dashboard"
                >
                  <span class="mr-3">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.4"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.2858 2H19.5524C20.9039 2 22.0003 3.1059 22.0003 4.47018V7.7641C22.0003 9.12735 20.9039 10.2343 19.5524 10.2343H16.2858C14.9333 10.2343 13.8369 9.12735 13.8369 7.7641V4.47018C13.8369 3.1059 14.9333 2 16.2858 2Z"
                        stroke="#2A2B61"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.44892 2H7.71449C9.06703 2 10.1634 3.1059 10.1634 4.47018V7.7641C10.1634 9.12735 9.06703 10.2343 7.71449 10.2343H4.44892C3.09638 10.2343 2 9.12735 2 7.7641V4.47018C2 3.1059 3.09638 2 4.44892 2Z"
                        stroke="#2A2B61"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.44892 13.7657H7.71449C9.06703 13.7657 10.1634 14.8716 10.1634 16.237V19.5299C10.1634 20.8941 9.06703 22 7.71449 22H4.44892C3.09638 22 2 20.8941 2 19.5299V16.237C2 14.8716 3.09638 13.7657 4.44892 13.7657Z"
                        stroke="#2A2B61"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.2858 13.7657H19.5524C20.9039 13.7657 22.0003 14.8716 22.0003 16.237V19.5299C22.0003 20.8941 20.9039 22 19.5524 22H16.2858C14.9333 22 13.8369 20.8941 13.8369 19.5299V16.237C13.8369 14.8716 14.9333 13.7657 16.2858 13.7657Z"
                        stroke="#2A2B61"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <p class="font-[MontRegular] text-base text-[#2A2B61]">
                    Dashboard
                  </p>
                </router-link>
              </li>
              <li>
                <router-link
                  exact-path
                  :to="{ name: 'courses' }"
                  class="flex py-1.5 pl-5 mb-3 s_sidebar ease-in-out duration-300"
                >
                  <span class="mr-3">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.4"
                        d="M17 18.4998H7"
                        stroke="#9295A3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        opacity="0.4"
                        d="M17 12.9998H7"
                        stroke="#9295A3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        opacity="0.4"
                        d="M11 7.49976H7"
                        stroke="#9295A3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M17.0502 0.999756C17.0502 0.999756 6.91551 1.00497 6.89967 1.00497C3.25611 1.02713 1 3.39454 1 7.00562V18.9939C1 22.6232 3.27327 24.9998 6.94851 24.9998C6.94851 24.9998 17.0818 24.9958 17.099 24.9958C20.7426 24.9737 23 22.605 23 18.9939V7.00562C23 3.37629 20.7254 0.999756 17.0502 0.999756Z"
                        stroke="#9295A3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <p class="font-[MontRegular]">Courses</p>
                </router-link>
              </li>
              <!-- <li>
                <router-link exact-path :to="{ name: 'resources' }"
                  class="flex py-1.5 pl-5 mb-3 s_sidebar ease-in-out duration-300">
                  <span class="mr-3">
                    <svg width="20" height="21" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="Bookmark">
                        <path id="Path_33968" fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.55877 19.1445L2.66923 22.8636C2.11915 23.1453 1.44147 22.9459 1.13822 22.4131V22.4131C1.05048 22.2481 1.00315 22.0651 1 21.8788V5.39976C1 2.2569 3.17956 0.999756 6.31601 0.999756H13.684C16.7247 0.999756 19 2.17309 19 5.19023V21.8788C19 22.1761 18.8801 22.4612 18.6668 22.6714C18.4535 22.8817 18.1641 22.9998 17.8624 22.9998C17.6699 22.9967 17.4808 22.9502 17.3095 22.8636L10.3774 19.1445C10.122 19.0085 9.81421 19.0085 9.55877 19.1445Z"
                          stroke="#9295A3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path id="Line_209" opacity="0.4" d="M6 8.49976H14" stroke="#9295A3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                    </svg>

                  </span>
                  <p class="font-[MontRegular]">
                    Resources
                  </p>
                </router-link>
              </li> -->
              <li>
                <router-link
                  exact-path
                  :to="{ name: 'chat' }"
                  class="flex py-1.5 pl-5 mb-3 s_sidebar ease-in-out duration-300"
                >
                  <span class="mr-3">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Chat">
                        <path
                          id="Path"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.0568 1.0002C7.54687 0.98602 4.28557 2.80716 2.4605 5.80047C0.635434 8.79378 0.512919 12.5225 2.13757 15.6288L2.33789 16.0192C2.50209 16.3265 2.53644 16.6865 2.43329 17.0192C2.14742 17.7785 1.90849 18.5546 1.71784 19.343C1.71784 19.743 1.83231 19.9716 2.26158 19.9621C3.0219 19.7942 3.77068 19.5779 4.50332 19.3145C4.81886 19.2276 5.15437 19.2477 5.45725 19.3716C5.73389 19.5049 6.2967 19.8478 6.31578 19.8478C9.99154 21.7806 14.4808 21.2473 17.5998 18.5075C20.7187 15.7677 21.8199 11.3901 20.3676 7.50416C18.9153 3.61821 15.2111 1.03065 11.0568 1.0002V1.0002Z"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Oval"
                          opacity="0.4"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M6.28751 11.4764C6.55093 11.4764 6.76448 11.2632 6.76448 11.0002C6.76448 10.7372 6.55093 10.524 6.28751 10.524C6.02409 10.524 5.81055 10.7372 5.81055 11.0002C5.81055 11.2632 6.02409 11.4764 6.28751 11.4764Z"
                          fill="#9295A3"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Oval_2"
                          opacity="0.4"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.057 11.4764C11.3205 11.4764 11.534 11.2632 11.534 11.0002C11.534 10.7372 11.3205 10.524 11.057 10.524C10.7936 10.524 10.5801 10.7372 10.5801 11.0002C10.5801 11.2632 10.7936 11.4764 11.057 11.4764Z"
                          fill="#9295A3"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Oval_3"
                          opacity="0.4"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.8266 11.4764C16.09 11.4764 16.3035 11.2632 16.3035 11.0002C16.3035 10.7372 16.09 10.524 15.8266 10.524C15.5632 10.524 15.3496 10.7372 15.3496 11.0002C15.3496 11.2632 15.5632 11.4764 15.8266 11.4764Z"
                          fill="#9295A3"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg>
                  </span>
                  <p class="font-[MontRegular]">Chat</p>
                </router-link>
              </li>
              <li>
                <router-link
                  exact-path
                  :to="{ name: 'schedule' }"
                  class="flex py-1.5 pl-5 mb-3 s_sidebar ease-in-out duration-300"
                >
                  <span class="mr-3">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Calendar">
                        <path
                          id="Line_200"
                          opacity="0.4"
                          d="M1 9.5H21"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Combined Shape"
                          opacity="0.4"
                          d="M6.11426 11.9407C5.28583 11.9407 4.61426 12.6122 4.61426 13.4407H6.11426V11.9407ZM6.12445 11.9407H6.11426V13.4407H6.12445V11.9407ZM7.62445 13.4407C7.62445 12.6122 6.95288 11.9407 6.12445 11.9407V13.4407H7.62445ZM6.12445 14.9407C6.95288 14.9407 7.62445 14.2691 7.62445 13.4407H6.12445V14.9407ZM6.11426 14.9407H6.12445V13.4407H6.11426V14.9407ZM4.61426 13.4407C4.61426 14.2691 5.28583 14.9407 6.11426 14.9407V13.4407H4.61426ZM11.0058 13.4407V11.9407C10.1773 11.9407 9.50576 12.6122 9.50576 13.4407H11.0058ZM11.0058 13.4407H9.50576C9.50576 14.2691 10.1773 14.9407 11.0058 14.9407V13.4407ZM11.0159 13.4407H11.0058V14.9407H11.0159V13.4407ZM11.0159 13.4407V14.9407C11.8444 14.9407 12.5159 14.2691 12.5159 13.4407H11.0159ZM11.0159 13.4407H12.5159C12.5159 12.6122 11.8444 11.9407 11.0159 11.9407V13.4407ZM11.0058 13.4407H11.0159V11.9407H11.0058V13.4407ZM15.8871 13.4407V11.9407C15.0586 11.9407 14.3871 12.6122 14.3871 13.4407H15.8871ZM15.8871 13.4407H14.3871C14.3871 14.2691 15.0586 14.9407 15.8871 14.9407V13.4407ZM15.8972 13.4407H15.8871V14.9407H15.8972V13.4407ZM15.8972 13.4407H15.8972V14.9407C16.7257 14.9407 17.3972 14.2691 17.3972 13.4407H15.8972ZM15.8972 13.4407H15.8972H17.3972C17.3972 12.6122 16.7257 11.9407 15.8972 11.9407V13.4407ZM15.8871 13.4407H15.8972V11.9407H15.8871V13.4407ZM15.8871 17.7161V16.2161C15.0586 16.2161 14.3871 16.8877 14.3871 17.7161H15.8871ZM15.8871 17.7161H14.3871C14.3871 18.5445 15.0586 19.2161 15.8871 19.2161V17.7161ZM15.8972 17.7161H15.8871V19.2161H15.8972V17.7161ZM15.8972 17.7161H15.8972V19.2161C16.7257 19.2161 17.3972 18.5445 17.3972 17.7161H15.8972ZM15.8972 17.7161H15.8972H17.3972C17.3972 16.8877 16.7257 16.2161 15.8972 16.2161V17.7161ZM15.8871 17.7161H15.8972V16.2161H15.8871V17.7161ZM11.0058 16.2161C10.1773 16.2161 9.50576 16.8877 9.50576 17.7161H11.0058V16.2161ZM11.0159 16.2161H11.0058V17.7161H11.0159V16.2161ZM12.5159 17.7161C12.5159 16.8877 11.8444 16.2161 11.0159 16.2161V17.7161H12.5159ZM11.0159 19.2161C11.8444 19.2161 12.5159 18.5445 12.5159 17.7161H11.0159V19.2161ZM11.0058 19.2161H11.0159V17.7161H11.0058V19.2161ZM9.50576 17.7161C9.50576 18.5445 10.1773 19.2161 11.0058 19.2161V17.7161H9.50576ZM6.11426 17.7161V16.2161C5.28583 16.2161 4.61426 16.8877 4.61426 17.7161H6.11426ZM6.11426 17.7161H4.61426C4.61426 18.5445 5.28583 19.2161 6.11426 19.2161V17.7161ZM6.12445 17.7161H6.11426V19.2161H6.12445V17.7161ZM6.12445 17.7161V19.2161C6.95288 19.2161 7.62445 18.5445 7.62445 17.7161H6.12445ZM6.12445 17.7161H7.62445C7.62445 16.8877 6.95288 16.2161 6.12445 16.2161V17.7161ZM6.11426 17.7161H6.12445V16.2161H6.11426V17.7161Z"
                          fill="#9295A3"
                        />
                        <path
                          id="Line_207"
                          d="M15.5 1V5"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Line_208"
                          d="M6.5 1V5"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Path"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.7092 3H6.30107C3.03808 3 1 4.77618 1 8.04107V17.8665C1 21.1828 3.03808 23 6.30107 23H15.6989C18.9722 23 21 21.2136 21 17.9487V8.04107C21.0103 4.77618 18.9825 3 15.7092 3Z"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg>
                  </span>
                  <p class="font-[MontRegular]">Schedule</p>
                </router-link>
              </li>
              <li>
                <router-link
                  exact-path
                  :to="{ name: 'profile' }"
                  class="flex py-1.5 pl-5 mb-3 s_sidebar ease-in-out duration-300"
                >
                  <span class="mr-3">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 20 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Profile">
                        <path
                          id="Ellipse_736"
                          opacity="0.4"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.5 13C12.5376 13 15 10.3137 15 7C15 3.68629 12.5376 1 9.5 1C6.46243 1 4 3.68629 4 7C4 10.3137 6.46243 13 9.5 13Z"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          id="Path_33945"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.00002 20.4969C0.998494 20.1075 1.08775 19.7228 1.26104 19.3719C1.80484 18.3107 3.33834 17.7482 4.61082 17.4935C5.52853 17.3024 6.45892 17.1747 7.39506 17.1114C9.12824 16.9629 10.8714 16.9629 12.6046 17.1114C13.5407 17.1754 14.471 17.3031 15.3889 17.4935C16.6613 17.7482 18.1948 18.2576 18.7386 19.3719C19.0871 20.0871 19.0871 20.9173 18.7386 21.6325C18.1948 22.7468 16.6613 23.2562 15.3889 23.5003C14.4722 23.6993 13.5415 23.8306 12.6046 23.893C11.1939 24.0097 9.77669 24.031 8.36301 23.9567C8.03673 23.9567 7.72133 23.9567 7.39506 23.893C6.46169 23.8314 5.53452 23.7001 4.6217 23.5003C3.33834 23.2562 1.81571 22.7468 1.26104 21.6325C1.08864 21.2776 0.999468 20.8897 1.00002 20.4969Z"
                          stroke="#9295A3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg>
                  </span>
                  <p class="font-[MontRegular]">Profile</p>
                </router-link>
              </li>
              <!-- <li>
                <router-link exact-path :to="{ name: 'settings' }"
                  class="flex py-1.5 pl-5 mb-3 s_sidebar ease-in-out duration-300">
                  <span class="mr-3">
                    <svg width="21" height="21" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="Setting">
                        <path id="Path_33946" fill-rule="evenodd" clip-rule="evenodd"
                          d="M20.709 7.11785L20.0091 5.88166C19.417 4.83566 18.1049 4.47481 17.0758 5.07499V5.07499C16.586 5.36871 16.0015 5.45204 15.4512 5.30661C14.901 5.16118 14.4301 4.79894 14.1425 4.29976C13.9575 3.98247 13.8581 3.62108 13.8544 3.25214V3.25214C13.8711 2.66063 13.6518 2.08743 13.2466 1.66311C12.8414 1.2388 12.2847 0.999512 11.7033 0.999756H10.2933C9.72371 0.999749 9.17763 1.23076 8.77586 1.64168C8.37409 2.0526 8.14976 2.60955 8.1525 3.18928V3.18928C8.13561 4.38623 7.17748 5.3475 6.00143 5.34738C5.63897 5.34354 5.28392 5.24235 4.97221 5.05404V5.05404C3.94317 4.45386 2.63103 4.8147 2.03894 5.86071L1.28761 7.11785C0.696233 8.16255 1.04592 9.49731 2.06981 10.1036V10.1036C2.73536 10.4947 3.14536 11.2175 3.14536 11.9998C3.14536 12.782 2.73536 13.5048 2.06981 13.8959V13.8959C1.04722 14.4981 0.697151 15.8296 1.28761 16.8712V16.8712L1.99777 18.1179C2.27519 18.6274 2.74065 19.0034 3.29115 19.1626C3.84166 19.3219 4.43182 19.2513 4.93104 18.9664V18.9664C5.4218 18.6749 6.00663 18.5951 6.55551 18.7446C7.1044 18.8941 7.57187 19.2606 7.85402 19.7626C8.03903 20.0799 8.13844 20.4413 8.1422 20.8102V20.8102C8.1422 22.0195 9.10527 22.9998 10.2933 22.9998H11.7033C12.8873 22.9998 13.8487 22.0259 13.8544 20.8207V20.8207C13.8516 20.2392 14.0774 19.6806 14.4814 19.2694C14.8854 18.8582 15.4341 18.6284 16.0054 18.6312C16.367 18.641 16.7206 18.7418 17.0347 18.9245V18.9245C18.061 19.5265 19.3723 19.1705 19.9679 18.1283V18.1283L20.709 16.8712C20.9958 16.37 21.0745 15.7732 20.9277 15.2128C20.7809 14.6524 20.4207 14.1747 19.9268 13.8855V13.8855C19.4329 13.5963 19.0726 13.1185 18.9258 12.5581C18.779 11.9977 18.8577 11.4009 19.1446 10.8998C19.3311 10.5683 19.6011 10.2934 19.9268 10.1036V10.1036C20.9445 9.49764 21.2934 8.17067 20.709 7.12833V7.12833V7.11785Z"
                          stroke="#9295A3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path id="Ellipse_737" opacity="0.4" fill-rule="evenodd" clip-rule="evenodd"
                          d="M11 14.9998C12.6569 14.9998 14 13.6566 14 11.9998C14 10.3429 12.6569 8.99976 11 8.99976C9.34315 8.99976 8 10.3429 8 11.9998C8 13.6566 9.34315 14.9998 11 14.9998Z"
                          stroke="#9295A3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                    </svg>

                  </span>
                  <p class="font-[MontRegular]">
                    Settings
                  </p>
                </router-link>
              </li> -->
            </ul>
          </div>

          <!-- <div class="px-6">
            <div class="mx-auto mb-2">
              <img src="../../assets/images/s-dashboard/Sales_Chart.svg" />
            </div>
            <div class="w-[140px] mx-auto text-center mb-8">
              <p class="font-[MontRegular] text-[rgba(146,149,163,1)] text-sm">
                Upgrade to
                <span class="text-[rgba(106,201,231,1)]">PRO</span> for more
                resources
              </p>
            </div>
            <div>
              <button class="fill-btn">Upgrade Now</button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div
      class="fixed top-0 right-0 left-0 bottom-0 bg-[#00000073] hidden z-30"
      id="sidebar-layer"
      @click="close"
    ></div>
  </div>
</template>

<script>
  export default {
    name: "student-sidebar",
    data() {
      return {
        element: document.querySelector("#sidebar"),
        layer: document.querySelector("#sidebar-layer"),
        location: this.$route.meta,
      };
    },
    methods: {
      close() {
        this.element.classList.add("close-sidebar");
        this.element.classList.remove("open-sidebar");
        this.layer.classList.remove("block");
        this.layer.classList.add("hidden");
      },
    },
    mounted() {
      this.element = document.querySelector("#sidebar");
      this.layer = document.querySelector("#sidebar-layer");
    },
  };
</script>

<style scoped>
  .router-link-exact-active {
    color: #2a2b61;
    background: linear-gradient(
      90deg,
      rgba(42, 43, 97, 1) 1%,
      rgba(229, 229, 241, 1) 1%,
      rgba(255, 255, 255, 1) 100%
    ) !important;
  }

  .dashboard {
    background: linear-gradient(
      90deg,
      rgba(42, 43, 97, 1) 1%,
      #e9fefb 0.5%,
      #4dc59100 100%
    ) !important;
  }

  .open-sidebar {
    transition: all 0.4s;
    left: 0px !important;
    padding-left: 0px;
    height: 100vh;
  }

  .close-sidebar {
    transition: all 0.4s;
    left: 0px !important;
  }
  @media only screen and (max-width: 1024px) {
    .close-sidebar {
      left: -300px !important;
    }
  }
</style>
